<template>
  <v-card>
    <v-card-title
      primary-title
      class="title"
    >
      <h5 class="title font-weight-black">
        {{ questionTitle }}
      </h5>
    </v-card-title>
    <vue-word-cloud
      :id="questionName"
      :words="words()"
      :color="'#403030'"
      :rotation="0"
      class="word-cloud"
    />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import stopList from "@/stopList.js";

export default {
  name: "WordCloud",
  props: {
    questionName: {
      type: String,
      default: ""
    },
    questionTitle: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapState({
      selectedSurveyNumber: state => state.survey.selectedSurveyNumber,
      responses: state =>
        state.charts.charts.filter(response => {
          return response.survey === state.survey.selectedSurveyNumber;
        })
    }),
    surveyNum() {
      return this.selectedSurveyNumber === null ? 0 : this.selectedSurveyNumber;
    }
  },
  methods: {
    words() {
      let wordCloud = [];

      const countWords = function(arr) {
        return arr.reduce((count, word) => {
          count[word] = (count[word] || 0) + 1;
          return count;
        }, {});
      };

      Object.filter = (obj, predicate) =>
        Object.keys(obj)
          .filter(key => predicate(obj[key]))
          .reduce((res, key) => ((res[key] = obj[key]), res), {});

      let wordList = this.responses
        .filter(
          response =>
            response.survey === this.selectedSurveyNumber &&
            response.response_json[this.questionName] !== undefined
        )
        .map(response => response.response_json[this.questionName].split(" "));

      let words = [].concat(...wordList);
      let filtered = words
        .filter(word => !stopList.stopList.includes(word))
        .map(word =>
          word
            .trim()
            .replace(/[^a-zA-Z ]/g, "")
            .toLowerCase()
        )
        .filter(word => !stopList.stopList.includes(word));
      wordCloud = countWords(filtered);

      // wordCloud = Object.filter(wordCloud, count => count >= 250); // fun fact: changing filter to include every word increases total word count from 125 to 2369, with the latter taking well over a minute to process
      // const formattedWordList = Object.entries(wordCloud);

      const formattedWordList = Object.entries(wordCloud).sort((a,b)=> b[1]-a[1]).slice(0, 100)
      // This max number can be changed to whatever it needs to be but 50 seems to be a good number of words that take 2-3 seconds to render

      return formattedWordList;
    }
  }
};
</script>

<style scoped>
.title {
  padding-bottom: 0%;
  margin-bottom: 0%;
}
.word-cloud {
  min-width: 400px;
  min-height: 350px;
}
</style>